document.addEventListener('DOMContentLoaded', function () {
    $('.faq-accordion').click(function () {
        $('.faq-panel.show').css('max-height', '0');
        $('.mobile-faq-panel.show').css('max-height', '100%');
    });

    $('.mobile-faq-menu').click(function () {
        $('.faq-panel.show').css('max-height', '0');
        $('.mobile-faq-panel.show').css('max-height', '0');
    });
});

document.addEventListener('DOMContentLoaded', function (event) {
    var acc = document.getElementsByClassName('faq-accordion');
    var panel = document.getElementsByClassName('faq-panel');

    for (var i = 0; i < acc.length; i++) {
        acc[i].onclick = function () {
            var setClasses = !this.classList.contains('active');
            setClass(acc, 'active', 'remove');
            setClass(panel, 'show', 'remove');

            if (setClasses) {
                this.classList.toggle('active');
                this.nextElementSibling.classList.toggle('show');
                this.nextElementSibling.style.maxHeight =
                    this.nextElementSibling.scrollHeight + 'px';
            }
        };
    }

    function setClass(els, className, fnName) {
        for (var i = 0; i < els.length; i++) {
            els[i].classList[fnName](className);
        }
    }
});

document.addEventListener('DOMContentLoaded', function (event) {
    var acc = document.getElementsByClassName('mobile-faq-menu');
    var panel = document.getElementsByClassName('mobile-faq-panel');

    for (var i = 0; i < acc.length; i++) {
        acc[i].onclick = function () {
            var setClasses = !this.classList.contains('active');
            setClass(acc, 'active', 'remove');
            setClass(panel, 'show', 'remove');

            if (setClasses) {
                this.classList.toggle('active');
                this.nextElementSibling.classList.toggle('show');
                this.nextElementSibling.style.maxHeight =
                    this.nextElementSibling.scrollHeight + 'px';
            }
        };
    }

    function setClass(els, className, fnName) {
        for (var i = 0; i < els.length; i++) {
            els[i].classList[fnName](className);
        }
    }
});

document.addEventListener('DOMContentLoaded', function (event) {
    $('.faq-accordion').click(function () {
        var pane = $(this);
        var headerHeight = $('.main-header').outerHeight();
        setTimeout(function () {
            var $panel = pane.parent();
            $('html,body').animate(
                {
                    scrollTop: $panel.offset().top - headerHeight,
                },
                500
            );
        }, 500);
    });

    $('.mobile-faq-menu').click(function () {
        $('.faq-accordion').removeClass('active');
        $('.faq-panel').removeClass('show');

        var pane = $(this);
        var headerHeight = $('.main-header').outerHeight();
        setTimeout(function () {
            var $panel = pane.parent();
            $('html,body').animate(
                {
                    scrollTop: $panel.offset().top - headerHeight,
                },
                500
            );
        }, 500);
    });
});

(function () {
    window.addEventListener('load', (event) => {
        if (window.location.href.split('#').pop() == 'cookieconfig') {
            document.getElementsByClassName('ot-sdk-show-settings')[0].click();
        }
    });
})();
